import {Directive, Input, HostListener, Inject} from '@angular/core';
import {NgModule} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Directive({selector: '[appCvsSetFocus]'})

/**
 * @author Sue Sammond
 */

/**
 * A directive to control focus for accessibility
 *
 * @Usage
 *
 * <button id="btn-error-link{{i}}"
 * appCvsSetFocus
 * targetElement="{{error.el}}">
 * {{error.errorText}}</button>
 */

export class SetFocusDirective {

  @Input() targetElement: string;

  constructor(@Inject(DOCUMENT) private _document) {
  }

  @HostListener('click')
  @HostListener('keydown.enter')
  onClick() {
    const focusElement = this._document.getElementById(this.targetElement);
    if (focusElement) {
      focusElement.focus();
    }
  }
}

